<template>
  <div class="iv-message">
    <div class="iv-main-width iv-p-t-20" >
      <Tab ref="tab" :navList="navList" @on-click="tabClick" v-if="show"></Tab>
      <component ref="learnContent" :is="learnContent" :name="learnContent"></component>
    </div>
  </div>
</template>

<script>
import Tab from '@/components/tab'
import opinionsing from './opinionsing'
import opinionsed from './opinionsed'
export default {
  data () {
    return {
      show: true,
      count: 0,
      hisCount: 0,
      learnContent: 'opinionsing',
    }
  },
  async created () {
    this.initTabs()
  },
  methods: {
    tabClick (name) {
      if (name === 'opinionsing') {
        this.learnContent = 'opinionsing'
      } else {
        this.learnContent = 'opinionsed'
      }
    },
    initTabs (data) {
      this.navList = [{
        label:`进行中`,
        name: 'opinionsing'
      },
      {
        label: `已结束`,
        name: 'opinionsed'
      }
      ]
    }
  },
  components: {
    Tab,
    opinionsing,
    opinionsed
  }
}
</script>

<style lang="scss" scoped>
.iv-message {
  // height: 100%;
  background-color: #fff;
  /deep/ .iv-drag-table {
    .ivu-table-row {
      .ivu-table-cell {
        font-size: 16px;
        color: rgba($color: #000000, $alpha: 0.65);
      }
    }
  }
}
</style>
